import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/forgot-password.png'
import _imports_1 from '@/assets/img/harapan-jaya.png'


const _hoisted_1 = { class: "password background-grey-lighten-5 w-100 h-100 pb-16 relative" }
const _hoisted_2 = { class: "flex card bg-white items-center" }
const _hoisted_3 = {
  id: "forgot-password",
  class: "image-left lg:w-1/2 lg:block md:hidden sm:hidden relative"
}
const _hoisted_4 = { class: "flex flex-col justify-between info px-6 pt-5" }
const _hoisted_5 = { class: "form pb-0 lg:w-1/2 md:w-full sm:w-full flex flex-col justify-between" }
const _hoisted_6 = { class: "p-fluid" }
const _hoisted_7 = { class: "p-field mb-6" }
const _hoisted_8 = { class: "invalid-feedback" }
const _hoisted_9 = {
  key: 1,
  class: "mx-auto font-bold text-white"
}

import {
  ref,
  onMounted,
  getCurrentInstance,
  reactive
} from 'vue'
import Button from 'primevue/button'
import Card from 'primevue/card'
import InputText from 'primevue/inputtext'
import { useRouter, useRoute } from 'vue-router'
import { Form, Field } from 'vee-validate'
import * as Yup from 'yup'
import ProgressSpinner from 'primevue/progressspinner'
import HjpAlertModal from '@/views/components/modal/HjpAlertModal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ForgotPassword',
  setup(__props) {

const loading = ref(false)
const router = useRouter()
const initialValues = {
  email: '',
}

const schema = Yup.object().shape({
  email: Yup.string().email('Email tidak valid').required('Email harus diisi'),
})

const attrModalConfirmation = reactive({
  show: false,
  title: 'Email Terkirim!',
  subTitle: 'Kami telah mengirimkan email berupa link untuk melakukan ubah password',
  btnSubmitTitle: 'Halaman Login',
  imgContent: require('@/assets/img/modal-confirmation/send-email.svg')
})

const onSubmit = (values: any) => {
  console.log('masukk submit', values)
  loading.value = true
  attrModalConfirmation.show = true
}

const hideDialog = () => {
  attrModalConfirmation.show = false
}

const toPage = (val: any) => {
  console.log('val', val)
  router.push({
    name: val
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "lg:hidden md:block sm:block px-10 py-16 top-info" }, [
      _createElementVNode("h4", { class: "text-white font-bold" }, "Lupa Password"),
      _createElementVNode("p", { class: "text-lg text-white" }, "Ubah password Anda melalui Email yang telah terdaftar")
    ], -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("p", {
              class: "mb-5 text-white text-xs cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toPage('Login')))
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "text-xs mr-3 pi pi-arrow-left" }, null, -1),
              _createTextVNode("Kembali ke Login")
            ])),
            _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "text-white" }, "Lupa Password", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-white" }, "Ubah password Anda melalui Email yang telah terdaftar", -1))
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "image-bottom" }, [
            _createElementVNode("img", {
              src: _imports_0,
              class: "w-80 mx-auto",
              alt: "logo"
            })
          ], -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _cache[7] || (_cache[7] = _createElementVNode("img", {
            src: _imports_1,
            class: "h-10 mx-auto",
            alt: "logo"
          }, null, -1)),
          _createVNode(_unref(Form), {
            onSubmit: onSubmit,
            "validation-schema": _unref(schema),
            "initial-values": initialValues,
            class: "p-16 w-full"
          }, {
            default: _withCtx(({ errors, setFieldValue, values }) => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { for: "email" }, "Email", -1)),
                  _createVNode(_unref(Field), { name: "email" }, {
                    default: _withCtx(({ handleChange, handleBlur }) => [
                      _createVNode(_unref(InputText), {
                        onChange: handleChange,
                        onBlur: handleBlur,
                        autofocus: "",
                        class: _normalizeClass(`input-primary`),
                        placeholder: "Ex. john@email.com",
                        modelValue: values.email,
                        "onUpdate:modelValue": ($event: any) => ((values.email) = $event)
                      }, null, 8, ["onChange", "onBlur", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(errors.email), 1)
                ])
              ]),
              _createVNode(_unref(Button), {
                class: "btn-primary",
                id: "submit-password",
                disabled: loading.value,
                type: "submit"
              }, {
                default: _withCtx(() => [
                  (loading.value)
                    ? (_openBlock(), _createBlock(_unref(ProgressSpinner), {
                        key: 0,
                        strokeWidth: "8",
                        fill: "white"
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, "Kirim Link Ubah Password"))
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-center color-blue-grey font-semibold text-xs" }, _toDisplayString('Version 1.0.0'), -1))
      ])
    ]),
    _createVNode(HjpAlertModal, {
      show: attrModalConfirmation.show,
      imgContent: attrModalConfirmation.imgContent,
      title: attrModalConfirmation.title,
      subTitle: attrModalConfirmation.subTitle,
      btnSubmitTitle: attrModalConfirmation.btnSubmitTitle,
      onHideDialog: hideDialog,
      onOnSubmit: _cache[1] || (_cache[1] = ($event: any) => (toPage('Login')))
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle"])
  ]))
}
}

})